import RulerLabel from './ruler-label.component';
export default RulerLabel;
